.merry-checkbox {
  display: grid;
  width: 24px;
  height: 24px;
  flex: none;
  padding: 0;
  cursor: pointer;
  border-radius: 50%;
  outline: none;
  place-items: center;
}

.merry-checkbox > svg {
  display: block;
}

.merry-checkbox[data-focus-visible] {
  outline: 2px solid #0061fe;
  outline-offset: 2px;
}

.merry-checkbox[data-disabled] {
  cursor: default;
  opacity: 0.4;
}
